import styles from "./CardHeader.module.css";

export default function CardHeader({ title, subtitle, meta, metaLink }) {
  return (
    <div className={styles.cardHeader}>
      <div>
        {title && <h3 className={styles.title}>{title}</h3>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {meta && (
        <span className={styles.meta}>
          {metaLink ? (
            <a
              href={metaLink}
              style={{ color: "var(--accent)" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {meta}
            </a>
          ) : (
            meta
          )}
        </span>
      )}
    </div>
  );
}
